import DataSheetBase from './DataSheetBase.js';

export default class DataSheet_drinks extends DataSheetBase {

  constructor(id, updateCb) {
    super(id, updateCb);
    this.requestedKeyPath = "";  // this value can be specified in the React Studio data sheet UI
  }

  makeDefaultItems() {
    // eslint-disable-next-line no-unused-vars
    let key = 1;
    // eslint-disable-next-line no-unused-vars
    let item;

    // The contents of this data sheet will be loaded by plugin 'Firebase (Cloud Firestore)'.
    
    item = {};
    this.items.push(item);
    item['image_path'] = "https://firebasestorage.googleapis.com/v0/b/slackclone-c5e5d.appspot.com/o/01d8cd3b-53ca-446a-b2a7-a04c716dabdb.jpg?alt=media&token=03962d5f-f97d-4e3e-bcaa-6c700665a338";
    item['document_key'] = "DlApgjOrVVYZ4TTaNsJM";
    item['description'] = "";
    item['price'] = "";
    item['drinkName'] = "";
    item.key = key++;
    
    item = {};
    this.items.push(item);
    item['image_path'] = "https://firebasestorage.googleapis.com/v0/b/slackclone-c5e5d.appspot.com/o/35b2da3d-1af8-4875-b0a7-7f8f19ba9853.png?alt=media&token=06489c53-b896-484a-bf40-06cc4d03bcae";
    item['document_key'] = "ighiZQ9KVRXYMQpPaldN";
    item['description'] = "Cherish the snom.";
    item['price'] = "Pats";
    item['drinkName'] = "Snom";
    item.key = key++;
    
    item = {};
    this.items.push(item);
    item['image_path'] = "";
    item['document_key'] = "jJFebRqzfoJHkA9bY89A";
    item['description'] = "I shouldn't be here";
    item['price'] = "bruh";
    item['drinkName'] = "how dare you";
    item.key = key++;
    
    item = {};
    this.items.push(item);
    item['image_path'] = "https://firebasestorage.googleapis.com/v0/b/slackclone-c5e5d.appspot.com/o/dacbc644-984a-455b-8e2b-e4879902db4f.jpg?alt=media&token=aacebe65-c450-441b-8c45-5c924797fb65";
    item['document_key'] = "ywUMzVl0ZIPHJOlUsGeH";
    item['description'] = "234324";
    item['price'] = "1";
    item['drinkName'] = "xb";
    item.key = key++;
  }

  
  // this function's implementation is provided by React Studio.
  _fetchComplete = (err, options) => {
    if (err) {
      console.log('** Web service write failed: ', err, options);
    } else {
      if (this.updateCb) this.updateCb(this);
    }
  }
  
  
  addItem(item, options) {
    console.log("add to firebase: ", item);
      
    let isCollectionGroup = options.servicePath.startsWith("group:");
    if (isCollectionGroup) {
      console.log("unable to add to collection group: ", options.servicePath.substring(6));
      return;
    }
  
    const db = this.firebase.firestore();
    const collection = db.collection(options.servicePath);
  
    let addItemPromise;
    if (item.document_key && item.document_key.length > 0) {
      let parsedItem = (({ document_key, ...item }) => (item))( item );
      addItemPromise = collection.doc(item.document_key).set(parsedItem);
    } else {
      addItemPromise = collection.add(item);
    }
    addItemPromise
      .then((docRef) => {
        var addedKey="";
        if (docRef) {
          console.log("Firebase document added with id: ", docRef.id);
          addedKey=docRef.id;
          item.document_key = docRef.id;
          item.document_ref = docRef;
        } else {
          console.log("Firebase document added with id: ", item.document_key);
          addedKey=item.document_key;
        }   
        if (this.onLastAddedDocumentKeyChanged != null) {
          this.onLastAddedDocumentKeyChanged(addedKey);
        }
        //super.addItem(item, options);
      
        this._fetchComplete(null, options);
      })
      .catch((error) => {
        console.error("Error adding document: ", error);
        this._fetchComplete(error, options);
      });
  }
  
  removeItem(item, options) {
    //super.removeItem(item, options);
    
    console.log("delete from firebase: ", item);
  
    //const db = this.firebase.firestore();
    //const collection = db.collection(options.servicePath);
    //const docRef = collection.doc(item.document_key);
    const docRef = item.document_ref;
    
    docRef.delete()
      .then(() => {
        this._fetchComplete(null, options);
      })
      .catch((error) => {
        console.error("Error deleting document: ", error);
        this._fetchComplete(error, options);    
      });
  }
  
  replaceItemByRowIndex(idx, item, options) {
    //super.replaceItemByRowIndex(idx, item, options);
    
    console.log("update in firebase: ", item);
  
    //const db = this.firebase.firestore();
    //const collection = db.collection(options.servicePath);
    //const docRef = collection.doc(item.document_key);
    const docRef = item.document_ref;
    
    docRef.update((({ key, document_ref, document_key, ...item }) => (item))( item ))
      .then(() => {
        this._fetchComplete(null, options);
      })
      .catch((error) => {
        console.error("Error updating document: ", error);
        this._fetchComplete(error, options);    
      });
  }
  

}
